module.exports = __webpack_public_path__ + "static/img/img_newsBg.f50e3af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_newsBg.jpg
// module id = nXhl
// module chunks = 1